import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Download, X, Share } from "lucide-react";
import { MillieAvatar } from "./MascotBubble";

const DISMISS_KEY = "sorted_install_dismissed";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || localStorage.getItem(DISMISS_KEY)) return;
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    let t;
    if (isIos) { setIos(true); t = setTimeout(() => setShow(true), 4000); }
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); clearTimeout(t); };
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferred(null);
  };

  return (
    <AnimatePresence>
      {show && (
        <div className="fixed bottom-24 inset-x-0 z-50 flex justify-center px-4 pointer-events-none" data-testid="install-prompt">
          <motion.div initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
            className="w-full max-w-md pointer-events-auto bg-white rounded-3xl border-2 border-[#FDECEF] shadow-floating p-4 flex items-center gap-3">
            <MillieAvatar size={44} float={false} mood="wink" />
            <div className="flex-1 min-w-0">
              <p className="font-heading font-semibold text-sorted-ink leading-tight">Pop me on your home screen</p>
              {ios ? (
                <p className="text-xs text-sorted-slate mt-0.5 flex items-center gap-1 flex-wrap">Tap <Share size={12} strokeWidth={2.5} className="inline" /> Share, then <b>Add to Home Screen</b></p>
              ) : (
                <p className="text-xs text-sorted-slate mt-0.5">Full-screen, one tap away — like a proper app.</p>
              )}
            </div>
            {!ios && (
              <button onClick={install} data-testid="install-btn" className="bg-sorted-rose text-white text-xs font-bold px-3 py-2 rounded-full flex items-center gap-1 shrink-0">
                <Download size={14} strokeWidth={2.5} /> Install
              </button>
            )}
            <button onClick={dismiss} aria-label="Dismiss" data-testid="install-dismiss" className="w-8 h-8 rounded-full bg-muted text-sorted-slate flex items-center justify-center shrink-0"><X size={14} strokeWidth={3} /></button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
